import React, { useState, createContext } from 'react';

import API from '../../api';

const WIntContext = createContext("");

const WIntProvider = props => {
    const [wIntAPIKey, setWIntAPIKey] = useState("");

    const getWIntAPIKey = (session) => {
        API.get("/org_settings/wint",
            {
                headers: { "Authorization": session.idToken.jwtToken },
                params: { org_name: session.idToken.payload.name }
            }
        )
            .then(res => {
                setWIntAPIKey(res.data)
            })
            .catch(err => {
                console.error("Failed to get W-Int API key:", err.response?.data || err.message);
            })
    }

    return (
        <WIntContext.Provider value={{
            wIntAPIKey,
            getWIntAPIKey
        }}>
            {props.children}
        </WIntContext.Provider>
    )
}

export { WIntProvider, WIntContext };
